export default function Clipboard() {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2934 7.36669L8.1667 13.4934C7.41613 14.2439 6.39815 14.6656 5.3367 14.6656C4.27524 14.6656 3.25726 14.2439 2.5067 13.4934C1.75613 12.7428 1.33447 11.7248 1.33447 10.6634C1.33447 9.6019 1.75613 8.58392 2.5067 7.83336L8.22003 2.12002C8.72041 1.61876 9.39941 1.33681 10.1077 1.33618C10.8159 1.33556 11.4954 1.61631 11.9967 2.11669C12.498 2.61706 12.7799 3.29607 12.7805 4.00433C12.7812 4.71259 12.5004 5.3921 12 5.89336L6.27336 11.6067C6.02318 11.8569 5.68385 11.9974 5.33003 11.9974C4.97621 11.9974 4.63688 11.8569 4.3867 11.6067C4.13651 11.3565 3.99596 11.0172 3.99596 10.6634C3.99596 10.3095 4.13651 9.97021 4.3867 9.72002L10.0467 4.06669"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
